import { render } from "./LegacySlideOverPanel.vue?vue&type=template&id=26488e03"
import script from "./LegacySlideOverPanel.vue?vue&type=script&lang=js"
export * from "./LegacySlideOverPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__